import React from 'react';
import Icon from '@Theme/natucare/components/Icon/Icon';
import { summaryPropTypes } from './SummaryPropTypes';
import * as styles from './Summary.module.scss';
const Summary = ({
  percent,
  heading,
  description,
  icon
}) => {
  if (!percent && !heading) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootIconWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    name: icon,
    classname: styles.rootIcon
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      height: `${percent}%`
    },
    className: styles.rootIconCoverWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    name: icon,
    classname: `${styles.rootIcon} ${styles.rootIconCover}`
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.rootBody
  }, percent && /*#__PURE__*/React.createElement("div", {
    className: styles.rootPercent
  }, percent, "%"), heading && /*#__PURE__*/React.createElement("div", {
    className: styles.rootHeading
  }, heading), description && /*#__PURE__*/React.createElement("p", {
    className: styles.rootDescription
  }, description)));
};
export default Summary;